import React, { useEffect, useRef, useState, useContext } from "react";
import ComedyBreadCrumb from "../comedyBreadCrumb";
import { useLocation,Link } from "react-router-dom";
import "../../../styles/comedyGalleries.css";
import ComedyGalleriesCard from "./galleryCard";
import Skeleton from "../skeleton";
import { DeviceContext } from "..";
import { Helmet } from "react-helmet-async";
import PageAds from "../../common/pageAds";



const ComedyGalleriesCat = ({ data }) => {
  //SSR data from server
  const ssrData = data?.[0].galleriesPage || {};
  const cards = ssrData.catData;
  const ssrGfId = ssrData.ssrGfId;
          
  
  //States
  const [breadCrumb,setBreadCrumb] = useState('')
  const [dataList, setDataList] = useState(cards || []);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hydrating, setHydrating] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(40); 
  const { mobile, setMobile,containerRef } = useContext(DeviceContext);

  const location = useLocation();
  const address = location.pathname;
  const addressBreak = address.substring(0, address.lastIndexOf("-"))
  let gal_id = address.substring(
    address.lastIndexOf("-") + 1,
    address.lastIndexOf(".html")
  );
 let gfId = addressBreak.substring(addressBreak.lastIndexOf("-") + 1,
    address.lastIndexOf(".html"))
 const gfIdRef = useRef(ssrGfId || gfId);
const isFirst = useRef(true)
 
    const contentscategories = [
    { text: "Chitti Archives", link: "/galleries/Chitti-Archive-11-1.html" },
  ];


  const isTelugu = (text) => /[\u0C00-\u0C7F]/.test(text);


   useEffect(() => {
      const match = contentscategories.find(item =>
      address.includes(item.link)
   );

    if (match) {
     setBreadCrumb({
       one: match.text,
       two: ""
    });
    } else {
    setBreadCrumb({
      one: "",
      two: ""
    });
  }
}, [address]);

  useEffect(() => {
    const t = setTimeout(() => setHydrating(false), 500);
    return () => clearTimeout(t);
  }, []);

  
  useEffect(() => {
    if (gfIdRef.current !== gfId) {
      gfIdRef.current = gfId;
      setPage(1);
      setDataList(null); 
    }
  }, [gfId]);


  useEffect(() => {
    
    if (hydrating) return;
       
   
  

     if (cards && gfIdRef.current === ssrGfId && page === 1 && isFirst.current) {
      setLoading(false);
     
      return;
    }


    else if (cards && gfIdRef.current === ssrGfId && page === 1 ) {
      setLoading(false);
      setDataList(cards)
     
      return;
    }
   
    const fetchData = async () => {
       setLoading(true)
      try {
     
        setMobile(window.innerWidth <= 768);
        const limit = window.innerWidth <= 768 ? 8 : 12;
       
        const start = (page - 1) * limit;
       
        const res = await fetch(
          `https://www.teluguone.com/comedy/comedyGalleryContentJson.php?gal_id=${gal_id}&gf_id=${gfId}&start=${start}&limit=${limit}`
        );
        if (!res.ok) throw new Error("Response not OK");
        const result = await res.json();
        if (result.comedy_gallery_content?.[1]?.msg) {
            setDataList(null)
            setError(null);
            return
        }
    
        setDataList(result.comedy_gallery_content.slice(1));
        setError(null);
      } catch (err) {
        setError(err.message);
        setDataList(null);
      } finally {
        setLoading(false);
         isFirst.current = false
      }
    };

    
    setDataList(null)
    fetchData();
  }, [gfId, page, hydrating]);

  //  Pagination logic — display 5 numbers between Prev/Next
  const renderPagination = () => {
    if (!totalPages) return null;
    const pagesPerBlock = 5;
    const startPage = Math.floor((page - 1) / pagesPerBlock) * pagesPerBlock + 1;
    const endPage = Math.min(startPage + pagesPerBlock - 1, totalPages);
    const pages = [];

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`pagination-btn ${i === page ? "galleries-cat-page-active" : ""}`}
          onClick={() => setPage(i)}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="galleries-cat-pagination">
        <button
          className={`${page !== 1 ? 'galleries-cat-pagination-arrow' : ''}`}
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          disabled={page === 1}
        >
          &laquo; Prev
        </button>

        {pages}

        <button
          className="galleries-cat-pagination-arrow"
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={page === totalPages}
        >
          Next &raquo;
        </button>
      </div>
    );
  };

  const getPicturePageLink = (ref_url) => {

        const items = ref_url.replace(".html", '').split("-")
        const pictureId = items[items.length - 2]
        return `/pictures/Chitti-Archive-${pictureId}.html`
  }

  

  return (
     <div className='comedy-galleries-page' style={{minHeight: `${(dataList && dataList.length > 8) ? '800px' : '400px' }`}}>
      <Helmet><title>Chitti | Fun Images | TeluguOne </title></Helmet>

            <ComedyBreadCrumb breadCrumb={{one:"Malliks" , two:'Chitti-Archive'}} />
      
          {(loading || hydrating) && !mobile &&
            Array(mobile ? 8 : 12)
              .fill("0")
              .map((__, index) => (
                
                  <div className="comedy-galleries-card" key={index}>
                    
                    <img
                      src="/comedy/assets/images/error_img.webp"
                      alt="small-img"
                      className="comedy-galleries-card-img"
                    />
                  </div>
              
              ))}

           {(loading) && mobile &&  Array(mobile ? 8 : 12).fill('0').map((__,index) => 
                              
                                
                                      <div className='comedy-galleries-mob-card' key={index}> 
                                        <Link to=""  >
                                         <div className='comedy-galleries-mob-card-img-container'>
                                             <img  src={`/comedy/assets/images/error_img.webp`} alt="comedy-galleries-mob-card-img" />
                                         </div> 
                                         </Link>
                                    </div>
                                
                            )}    

          {dataList && dataList.length > 1 && !mobile &&
            dataList.map((item, index) => {

               if (item.msg)  {
                 return;
               }

              return <ComedyGalleriesCard key={index} item={item} index={index} hydrating={hydrating} />
                 
          })} 
 

           {dataList && dataList.length > 1 && mobile && 
            dataList.map((item, index) => {
                    
               if (item.msg)  {
                 return;
               }

                            
                 return <div className={`comedy-galleries-mob-card ${hydrating ? 'ssr-hidden' : ''}`} key={index} >
                            
                             <Link to={item.url_link ? getPicturePageLink(item.url_link) : '/'}  >
                           
                                <div className='comedy-galleries-mob-card-img-container'>
                                <img   loading={ index === 0 ? "eager" : index < 4 ? "auto" : "lazy"}
                                fetchpriority={index === 0 ? "high"  : index < 4 ? "auto"  : "low" } src={item.stimg ? item.stimg : '/comedy/assets/images/error_img.webp'} alt="comedy-galleries-mob-card-img" />
                                </div>
                             
                             </Link>
                         
                         
                   </div>
             
           })}


          {error && (
            <div className="col-12">
              <div className="json-loading-error-div">
                <img
                  loading="eager"
                  src="/comedy/assets/images/json_error.png"
                  alt="json_error"
                />
              </div>
            </div>
          )}
       

        {/* Pagination */}
        {mobile && !hydrating && dataList && dataList.length === 8 && renderPagination()}
        {!mobile && !hydrating && dataList && dataList.length === 12 && renderPagination()}
         {dataList &&  !error && !loading && dataList.length === 1 && <p className="gal-no-more">No More Data......</p>}
       <PageAds  mobile={mobile} containerRef={containerRef} />
    </div>
  );
};

export default ComedyGalleriesCat;
